(() => {
  'use strict';

  class VariantDescriptionHandler {
    constructor() {
      this.variantTemplate = document.querySelector('.variant-template');
      if (!this.variantTemplate) return;

      this.variantDescriptionElement = this.variantTemplate.querySelector('.js-variant-description .variant-description-content');
      if (!this.variantDescriptionElement) return;

      this.variantDescriptionsDataElement = document.querySelector('[data-variant-descriptions]');
      if (!this.variantDescriptionsDataElement) return;

      try {
        this.variantDescriptionsData = JSON.parse(this.variantDescriptionsDataElement.innerHTML);
      } catch (error) {
        console.error('Variant template: Error parsing variant descriptions:', error);
        return;
      }

      this.mediaItems = this.variantTemplate.querySelectorAll('.media-item');
      this.product = window.theme?.product;

      this.init();
    }

    init() {
      this.setupVariantSelectorListeners();
      this.setupMediaClickHandlers();
      this.setupProductDefaultOverride();
    }

    setupVariantSelectorListeners() {
      const swatchContainer = this.variantTemplate.querySelector('swatch-component');
      if (!swatchContainer) return;

      const optionSelectors = swatchContainer.querySelectorAll('.js-option-item, select.single-option-selector');
      optionSelectors.forEach(selector => {
        selector.addEventListener('change', () => {
          setTimeout(() => this.updateFromCurrentSelection(), 50);
        });
      });
    }

    updateFromCurrentSelection() {
      const swatchContainer = this.variantTemplate.querySelector('swatch-component');
      if (!swatchContainer || !this.product) return;

      const selectedOptions = {};
      for (let i = 1; i <= 3; i++) {
        const optionKey = 'option' + i;
        const radioInput = swatchContainer.querySelector(`input[name="${optionKey}"]:checked`);
        if (radioInput) {
          selectedOptions[optionKey] = radioInput.value;
          continue;
        }
        const selectInput = swatchContainer.querySelector(`select[name="${optionKey}"]`);
        if (selectInput) {
          selectedOptions[optionKey] = selectInput.value;
        }
      }

      const variant = this.product.variants.find(v =>
        Object.keys(selectedOptions).every(key => v[key] === selectedOptions[key])
      );

      if (variant) {
        this.updateVariantDescription(variant);
        this.updateProductImage(variant);
      }
    }

    setupProductDefaultOverride() {
      if (window.ProductDefault) {
        this.overrideProductDefault();
      } else {
        const checkInterval = setInterval(() => {
          if (window.ProductDefault) {
            clearInterval(checkInterval);
            this.overrideProductDefault();
          }
        }, 100);
        setTimeout(() => clearInterval(checkInterval), 5000);
      }
    }

    overrideProductDefault() {
      const originalOnLoad = window.ProductDefault.onLoad;
      const self = this;

      window.ProductDefault.onLoad = function() {
        originalOnLoad.call(this);
        self.productInstance = this;
        self.product = this.product;
        self.mainSlider = this.mainSlider;

        const originalHandler = this.handleVariantChange.bind(this);
        this.handleVariantChange = function(variant) {
          originalHandler(variant);
          self.updateVariantDescription(variant);
          self.updateProductImage(variant);
        };
      };
    }

    updateVariantDescription(variant) {
      if (!variant || !this.variantDescriptionElement) return;

      const variantData = this.variantDescriptionsData[variant.id];
      if (variantData && variantData.description) {
        let description = variantData.description;
        if (typeof description === 'object' && description !== null) {
          description = description.value || description.toString();
        }
        this.variantDescriptionElement.style.opacity = '0.5';
        this.variantDescriptionElement.style.transition = 'opacity 0.2s ease';
        setTimeout(() => {
          this.variantDescriptionElement.innerHTML = description;
          this.variantDescriptionElement.style.opacity = '1';
        }, 200);
      }
    }

    updateProductImage(variant) {
      if (!variant) return;

      const variantImage = variant.featured_image || variant.featured_media;
      if (!variantImage) return;

      let mediaIndex = -1;
      if (this.product && this.product.media) {
        mediaIndex = this.product.media.findIndex(media => {
          if (media.id === variantImage.id) return true;
          if (media.src && variantImage.src && media.src === variantImage.src) return true;
          if (media.variant_ids && media.variant_ids.includes(variant.id)) return true;
          return false;
        });
      }

      if (mediaIndex >= 0) {
        if (this.mainSlider) {
          this.mainSlider.goTo(mediaIndex);
        } else if (this.productInstance?.mainSlider) {
          this.productInstance.mainSlider.goTo(mediaIndex);
        } else if (this.mediaItems[mediaIndex]) {
          this.mediaItems[mediaIndex].click();
        }
      }
    }

    setupMediaClickHandlers() {
      if (!this.mediaItems.length) return;

      this.mediaItems.forEach((item, index) => {
        item.style.cursor = 'pointer';
        item.addEventListener('click', () => this.handleMediaClick(index));
      });
    }

    handleMediaClick(index) {
      const product = this.product || this.productInstance?.product;
      if (!product || !product.media || !product.media[index]) return;

      const media = product.media[index];
      let variant = null;

      if (media.variant_ids && media.variant_ids.length > 0) {
        variant = product.variants.find(v => v.id === media.variant_ids[0]);
      }
      if (!variant && media.id) {
        variant = product.variants.find(v => v.featured_image && v.featured_image.id === media.id);
      }
      if (!variant && media.src) {
        variant = product.variants.find(v => v.featured_image && v.featured_image.src === media.src);
      }

      if (!variant) return;

      this.updateVariantDescription(variant);
      this.updateVariantSelectors(variant);
    }

    updateVariantSelectors(variant) {
      const swatchContainer = this.productInstance?.elms?.swatchContainer ||
                             this.variantTemplate.querySelector('swatch-component');
      if (!swatchContainer) return;

      for (let i = 1; i <= 3; i++) {
        const optionKey = 'option' + i;
        const optionValue = variant[optionKey];
        if (!optionValue) continue;

        const radioInput = swatchContainer.querySelector(
          `input[name="${optionKey}"][value="${optionValue}"]`
        );
        if (radioInput && !radioInput.checked) {
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const selectInput = swatchContainer.querySelector(`select[name="${optionKey}"]`);
        if (selectInput && selectInput.value !== optionValue) {
          selectInput.value = optionValue;
          selectInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  function initHandler() {
    let attempts = 0;
    const checkProduct = () => {
      attempts++;
      if (window.theme?.product || document.querySelector('.variant-template')) {
        new VariantDescriptionHandler();
      } else if (attempts < 20) {
        setTimeout(checkProduct, 100);
      }
    };
    setTimeout(checkProduct, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHandler);
  } else {
    initHandler();
  }
})();
